import React, { useEffect, useState } from 'react';

import { Button, Modal } from 'antd';

import { UserActivityEvent } from './models';

export type EventItemModalProps = {
  event: UserActivityEvent | null;
  onClose: () => void;
};

const EventItemModal: React.FC<EventItemModalProps> = (props) => {
  const [eventObjectString, setEventObjectString] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (props.event) {
      setEventObjectString(JSON.stringify(props.event, null, 2));
    } else {
      setEventObjectString(undefined);
    }
  }, [props.event]);

  return (
    <Modal
      title="Event Details"
      open={!!props.event}
      onCancel={props.onClose}
      footer={[
        <Button key="submit" type="primary" onClick={props.onClose}>
          Ok
        </Button>,
      ]}
      width={800}
    >
      <div className="event-item-modal">
        <pre>{eventObjectString}</pre>
      </div>
    </Modal>
  );
};

export default EventItemModal;
